module.exports = JSON.parse("{\"timestamp\":\"23.10.2026 - 02:33:09\",\"brands\":[]}")